import React from "react";
import "./Skills.css";

const Skills = () => {
  return (
    <section className="skills-section">
      <h2 className="skills-title">Skills</h2>
      <div className="skills-grid">
        {/* Card 1: Technical Skills */}
        <div className="skill-category">
          <h3>Technical Skills</h3>
          <div className="skill-icons">
            <i className="fas fa-code"></i>
          </div>
          <p>Data Structures, Full Stack Development, Git, GitHub</p>
        </div>

        {/* Card 2: Languages */}
        <div className="skill-category">
          <h3>Languages</h3>
          <div className="skill-icons">
            <i className="devicon-java-plain colored"></i>
            <i className="devicon-python-plain colored"></i>
            <i className="devicon-javascript-plain colored"></i>
            <i className="devicon-c-plain colored"></i>
          </div>
          <p>Java, Python, C, JavaScript, SQL</p>
        </div>

        {/* Card 3: Frameworks */}
        <div className="skill-category">
          <h3>Frameworks</h3>
          <div className="skill-icons">
            <i className="devicon-react-original colored"></i>
            <i className="devicon-nodejs-plain colored"></i>
            <i className="devicon-mongodb-plain colored"></i>
            <i className="devicon-express-original"></i>
          </div>
          <p>MongoDB, ExpressJS, ReactJS, NextJS</p>
        </div>

        {/* Card 4: Soft Skills */}
        <div className="skill-category">
          <h3>Soft Skills</h3>
          <div className="skill-icons">
            <i className="fas fa-comments"></i>
            <i className="fas fa-lightbulb"></i>
            <i className="fas fa-users"></i>
          </div>
          <p>
            Communication, Problem Solving, Work Ethic, Teamwork, Leadership
          </p>
        </div>
      </div>
    </section>
  );
};

export default Skills;
